export const UPLOAD_CREATIVES_REQUEST = "UPLOAD_CREATIVES_REQUEST";
export const UPLOAD_CREATIVES_SUCCESS = "UPLOAD_CREATIVES_SUCCESS";
export const UPLOAD_CREATIVES_ERROR = "UPLOAD_CREATIVES_ERROR";
export const UPLOAD_CREATIVES_RESET = "UPLOAD_CREATIVES_RESET";

export const GET_CREATIVES_REQUEST = "GET_CREATIVES_REQUEST";
export const GET_CREATIVES_SUCCESS = "GET_CREATIVES_SUCCESS";
export const GET_CREATIVES_ERROR = "GET_CREATIVES_ERROR";
export const GET_CREATIVES_RESET = "GET_CREATIVES_RESET";

export const GET_ALL_BRAND_AND_NETWORK_REQUEST =
  "GET_ALL_BRAND_AND_NETWORK_REQUEST";
export const GET_ALL_BRAND_AND_NETWORK_SUCCESS =
  "GET_ALL_BRAND_AND_NETWORK_SUCCESS";
export const GET_ALL_BRAND_AND_NETWORK_FAIL = "GET_ALL_BRAND_AND_NETWORK_FAIL";
export const GET_ALL_BRAND_AND_NETWORK_RESET =
  "GET_ALL_BRAND_AND_NETWORK_RESET";
